
    import * as React from 'react';

    const ShoppingBag24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M8 9V6a4 4 0 118 0v3h6v13H2V9h6zm1 0h6V6a3 3 0 00-6 0v3zm-1 1H3v11h5V10zm1 0v11h6V10H9zm7 0v11h5V10h-5z" /></svg>
        </div>
      );
    };

    ShoppingBag24.displayName = 'ShoppingBag24';

    export default ShoppingBag24;
  